<template>
  <div class="index">
    <div class="container banner">
        <div class='page_width'>
        <div class="banner_left">
          <!-- <div class="left_title " v-animate="'animate__animated animate__slideInUp'">Unleash the Adventure Live the Game!</div> -->
          <!-- <div class="left_title " v-animate="'animate__animated animate__slideInDown'">FUTURE LASER TECH LLC</div> -->
          <!-- <div class="left_msg " v-animate="'animate__animated animate__slideInUp'">Plunge into captivating gameplay, unravel thrilling mysteries, and savor uninterrupted excitement like never before.</div> -->
          <!-- <div class="left_text" v-animate="'animate__animated animate__fadeInDown'">Plunge into captivating gameplay, unravel thrilling mysteries, and savor uninterrupted excitement like never before.</div> -->
          <div class="left_bottom " v-animate="'animate__animated animate__fadeInDown'">
            <router-link to="contactus">
              <span class="bg_btn pointer color2 ">
              <span class="">Contact us</span>
              <i class="arrow el-icon-caret-right"></i>
            </span>
            </router-link>
          </div>
        </div>    
      </div> 
      <img src="../../assets/image/fgx.png" alt="" class="line"> 
    </div>
    <div class="container pt_container"> 
        <div class="page_thumb">
          <div class="page_container">    
            <div class="grid grid_group">
              <div class="grid_md_4 grid_xs_4 grid_sm_4">
                <div class="game_group group_1">                    
                   <div class="item_inner">
                    <div class="group_img"> <img src="../../assets/image/tb1.png" alt=""> </div>
                    <div class="inner_title">Game Development</div>
                    <div class="inner_msg">Our skilled developers craft captivating and immersive games for multiple platforms, ensuring every player enjoys a seamless experience.</div>
                  </div>
                </div>
              </div>
              <div class="grid_md_4 grid_xs_4 grid_sm_4">
                <div class="game_group">
                  <div class="item_inner">
                     <div class="group_img"> <img src="../../assets/image/tb2.png" alt=""> </div>
                    <div class="inner_title">Indie Publishing</div>
                    <div class="inner_msg">Elevate your game with our expert publishing services, offering full support to bring your vision to the global stage.</div>
                  </div>
                </div>
              </div>    
              <div class="grid_md_4 grid_xs_4 grid_sm_4">
                <div class="game_group group_2">                    
                    <div class="item_inner">
                     <div class="group_img"> <img src="../../assets/image/tb3.png" alt=""> </div>
                    <div class="inner_title">3D Game Design</div>
                    <div class="inner_msg">We build vibrant worlds and compelling narratives, creating games that spark excitement and keep players engaged.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>   
    </div>

    <div class="container">   
      <div class="page_width  ">
        <div class="page_thumb ">
          <div class="page_container cate_container"> 
            <div class="grid grid_md_gap grid_gap_none ">
              <div class="grid_md_6 grid_xs_12 grid_sm_12 flex_col_center">
                <div class="item_group">
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container" >
                        <div class="item_img" v-animate="'animate__animated animate__rotateInDownLeft'">
                          <img src="../../assets/image/tu1.png" alt="">
                        </div>
                        <div class="mini_title">ABOUT US</div>
                        <!-- <div class="half_msg">Traverse the cosmos and steel yourself for epic clashes.</div> -->
                        <div class="half_text" style="margin-top:20px;">From concept to completion, we’re committed to crafting high-quality indie games that captivate and inspire.</div>
                      </div>
                    </div>
                  </div> 
                </div>
              </div>
              <div class="grid_md_6 grid_xs_12 grid_sm_12">
                <div class="item_group">
                  <div class="item_inner">
                    <div class="group_half flex_col_sb">
                      <div class="half_container" >
                        <div class="half_text">FUTURE LASER is a passionate game development studio focused on innovation and quality. We blend creativity with cutting-edge technology to deliver extraordinary gaming adventures for players around the world.</div>
                        <router-link to="aboutus" class="btn_link">
                          <span class="bg_btn pointer color2 ">
                            <span class="">GET IN TOUCH</span>
                            <i class="arrow el-icon-caret-right"></i>
                          </span>
                        </router-link>
                      
                        <div class="item_img" v-animate="'animate__animated animate__rotateIn'">
                          <img src="../../assets/image/tu2.png" alt="">
                        </div>
                        
                        
                      </div>
                    </div>
                  </div> 
                </div>
               
                
              </div>
             
            </div>
          </div>
        
        </div>
        
      </div>
    </div> 

    <div class="container" > 
        <div class="page_thumb">
          <div class="page_container cate_container">
            <div class="grid  games_container" >
              <div class="grid_md_12 grid_xs_12 grid_sm_12 " v-for="(item,index) in games" :key="index" >
                <div class="item_group">
                      <div class="thumb_wrap">  
                        <div class="half_wrap">
                          <div class="wrap_img"><img :src="item.img" alt=""></div>
                          <div class="wrap_info flex_warp">
                            <div class="wrap_title color1" >{{ item.title }}</div>
                            <!-- <div class="wrap_text color1">{{ item.info }}</div> -->
                            <!-- <div class="text_bottom bg_btn flex_center pointer" @click="toPage(item)">
                              <span class="color4">{{item.status=='1'?'Learn More':'Stay tuned'}}</span>
                            </div> -->
                          </div>
                        </div>  
                      </div>
                </div>
              </div>
            </div>
            
          </div>

        </div> 
       
    </div>
    <div class="container">
      <div class="page_width">
        <div class="cate_container">
          <div class="one_group">
            <img src="../../assets/image/yhbg.png" alt="" class="bg_img">
            <div class="one_title">OUR EXPERTISE</div>
            <img src="../../assets/image/tu3.png" alt="" class="one_img">
            <div class="one_inner flex">
              <div class="img_group flex">
                <img src="../../assets/image/tx_4.png" alt="">
                <img src="../../assets/image/tx_5.png" alt="">
                <img src="../../assets/image/tx_2.png" alt="">
              </div>
              <div class="inner_text df_font flex_center">Specializing in User Interface, User Experience, Product Design, Branding, and Motion Design to create polished and engaging games.</div>
            </div>
          </div>
        </div>
        <!-- <div class="cate_container"> 
          <div class="one_group_2">
            <div class="one_title_img"><img src="../../assets/image/JOIN US.png" alt=""></div>
            <div class="inner_tools">
              <div class="one_tool flex_sb">
                <div class="tool_head flex">
                  <div class="head_title">Lead Game Designer</div>
                  <div class="head_msg color8">/ Status: Recruiting</div>
                </div>
                
                <div class="pointer tool_tab  flex_center" @click="toPage('/join')">
                  <span class="">APPLY NOW</span> <i class="arrow el-icon-caret-right"></i>
                </div>
              </div>
              <div class="one_tool flex_sb">
                <div class="tool_head flex">
                  <div class="head_title">Senior 3D Environment Artist</div>
                  <div class="head_msg color8">/ Status: Recruiting</div>
                </div>
                <div class="pointer tool_tab  flex_center " @click="toPage('/join')">
                  <span class="">APPLY NOW</span> <i class="arrow el-icon-caret-right"></i>
                </div>
              </div>
              <div class="one_tool flex_sb">
                <div class="tool_head flex">
                  <div class="head_title">Community Engagement Manager</div>
                  <div class="head_msg color8">/ Status: Recruiting</div>
                </div>
                <div class="pointer tool_tab  flex_center" @click="toPage('/join')">
                  <span class="">APPLY NOW</span> <i class="arrow el-icon-caret-right"></i>
                </div>
              </div>
              <div class="one_tool flex_sb">
                <div class="tool_head flex">
                  <div class="head_title">Narrative Story Developer</div>
                  <div class="head_msg color8">/ Status: Recruiting</div>
                </div>
                <div class="pointer tool_tab flex_center" @click="toPage('/join')">
                  <span class="">APPLY NOW</span> <i class="arrow el-icon-caret-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cate_container">
          <div class="one_group_3">
            <div class="one_title_3">What Players Are Raving About</div>
            <div class="one_card">
              <div class="one_star_group flex">
                <img src="../../assets/image/xx.png" alt="">
                <img src="../../assets/image/xx.png" alt="">
                <img src="../../assets/image/xx.png" alt="">
                <img src="../../assets/image/xx.png" alt="">
                <img src="../../assets/image/xx.png" alt="">
              </div>
              <div class="card_msg">“Neon Drift is a masterpiece! It blends action, strategy, and exploration perfectly. The vibrant world and meaningful choices kept me hooked. Excited for KTG's next release!”</div>
              <div class="card_tool flex_sb">
                <div class="tool_head flex">
                  <div class="head_img"><img src="../../assets/image/tx_5.png" alt=""></div>
                  <div class="head_name">James</div>
                </div>
                <div class="tail_img"><img src="../../assets/image/syh.png" alt=""></div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- <div class="container pl_container"> 
      <div class="page_width page_top ">  
        <div class="page_thumb ">
          <div class="page_container cate_container">    
                <div class="grid grid_md_gap grid_gap_none ">
                 <div class="grid_md_8 grid_xs_12 grid_sm_12 ">
                    <div class="pl_group">
                      <div class="pl_inner">
                        <div class="pl_grid flex">
                          <div class="group_img">
                            <img src="../../assets/image/tu4.png" alt="">
                          </div>
                          <div class="pl_box" >
                            <div class="box_title">STAY CONNECTED</div>
                            <div class="box_msg" >Join over 200K subscribers to receive our biggest updates directly in your inbox.</div>
                            <div class="star_group flex_center">
                              <input type="text" v-model="sms" placeholder="EMAIL ADDRESS" >
                              <div class="sms_btn flex_center_end pointer"><span>SUBSCRIBE</span><img src="../../assets/image/jt4.png" alt=""></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 </div>
                 <div class="grid_md_4 grid_xs_12 grid_sm_12 ">
                    <div class="pl_group">
                      <div class="pl_inner">
                        <div class="pl_grid flex "> 
                          <div class="pl_box bg_1 color2 " style="padding:30px 20px;">
                            <div class="box_title" style="font-size: 22px;">Ready to create something extraordinary with us?</div>
                            <div class="box_msg" style="text-align: center;">Check out our open positions.</div>
                            <span class="bg_btn pointer color2 ">
                              <span class="">WORKING WITH US</span>
                              <i class="arrow el-icon-caret-right"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                 </div>
               </div>
          </div>
        </div>   
      </div>
    </div>
     -->

     
    <!-- <div class="container page_banner game_banner ">
      <div class='page_width'>
        <div class="page_title" v-animate="'animate__animated animate__lightSpeedInLeft'">
          <div class="title_name">Contact us</div>
        </div>
        <div class="banner_info" v-animate="'animate__animated animate__slideInDown'">
          <div class="info">Address：3235 Leonidas Street, 
New Orleans, LA 70118</div>
          <div class="info">Email：support@futurelastertech.com</div>
        </div>
      </div>
    </div> -->
  </div>

</template>

<script>
import { swiper, swiperSlide,} from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import icon1 from '../../assets/image/tx_1.png'
import icon2 from '../../assets/image/tx_2.png'
import icon3 from '../../assets/image/tx_3.png'

export default {
  components: {
    swiper,
    swiperSlide, 
  },
  data () {
    return {
      tabId:'1',
      screenWidth: document.body.clientWidth,
      swiperOption: {},
      swiperOption2: {},
      gameList:[],
      loadFlag:false,
      fk_list:[
        {img:icon1,title:'Sarah T',msg:'Absolutely love the immersive games and vibrant community! The website is sleek and easy to navigate. A must-visit for gamers!',rate:5,},
        {img:icon2,title:'Jake R',msg:'Great selection of unique titles and engaging content. Customer support is responsive, but load times could be faster.',rate:4,},
        {img:icon3,title:'Emma L',msg:'Fantastic storytelling in their games! The site’s design is intuitive, though I’d love more frequent updates on new releases.',rate:4,},
      ],
      sms:'',
    }
  },
  created () {
   
    this.getGames()
  },
  methods: {
    setOptions(){
      this.swiperOption = {
        loop: false,
        autoplay: false,
        slidesPerView:3.4,
        centeredSlides : false,
        spaceBetween: 50,
        // freeMode: true,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
          el:'.swiper-pagination',
          clickable:true
        },
        breakpoints: { 
          //当宽度小于等于320
          767: {
            slidesPerView: 1.2,
          },
          
        },
      }
   
    },
    setOptions2(){
      this.swiperOption2 = {
        loop: false,
        autoplay: false,
        // slidesPerView:1,
        // centeredSlides : false,
        spaceBetween: 0,
        // freeMode: true,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,  //修改swiper的父元素时，自动初始化swiper
        observeSlideChildren:true,
        pagination:{
          el:'.swiper-pagination2',
          clickable:true
        },
       
      }
   
    },
    toPage(path){
      
        this.$router.push(path)

      
    },

    windowScroll() {
    // 滚动条距离页面顶部的距离
    // 以下写法原生兼容
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if(scrollTop > 0){
      this.$store.state.isFloat = true
    }else{
      this.$store.state.isFloat = false
    }

    },
    getGames(){

     let games =  this.$store.state.games 
     let gameList=games.slice(0,3)
     this.gameList = gameList
    }
  

    
    
  },
  mounted () {
    window.onresize = () => {
      this.screenWidth = window.innerWidth
    },
    window.addEventListener('scroll', this.windowScroll);
    
  },
  computed:{
   
    mySwiper(){
      return this.$refs.mySwiper.swiper
    },
    mySwiper(){
      return this.$refs.mySwiper.swiper2
    },
    joinList(){ return this.$store.state.joinList },
    games(){ return this.$store.state.games }
  },
  watch: {
    // "$store.state.page": {
    //   handler: function (newVal) {
    //     this.name = newVal
    
    //   }
    // },
    
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.windowScroll);
  },


  
}
</script>
<style lang='scss' scoped>
.index {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color:#fff;
  margin-top:-80px;
  .banner{
    background-image:url(../../../public/bg/bn.png);
    background-size: 100% 100%;
    height:890px;
    background-position: center center;
    background-repeat: no-repeat;
    overflow: hidden;
    position: relative;
    z-index: 1;
    .banner_left{
      position: absolute;
      top: 72%;
      z-index: 1;
      width:100%;
      left:0%;

      // transform: translateX(-50%);
      color:$theme_color1;
      text-align: center;
      
      .left_title{
        font-size: 100px;
        font-weight: bold;
        letter-spacing: 4px;
       
      }
      .left_msg{
        font-family: PingFang SC, PingFang SC;
        font-size: 40px;
        line-height: 1.4;
      }
      .left_bottom{
        text-align: left;
        font-size: 24px;
        margin-top:30px;
        .bg_btn{
          padding:10px 20px;
        }
        .arrow{
          display: inline-block;
          width: 14px;
          margin-left:8px;
          position: relative;
          top:2px;
        }
        
      }
      .left_text{
        font-size: 30px;
        margin-top:20px;
        line-height: 1.2;
        padding-right:60px;
        font-weight: 100;
      }
    }
    .line{
      position: absolute;
      bottom:0;
      left:0;
      right:0;
      width: 100%;
      height: 67px;
      z-index: 2;
    }
    
  }
  .page_top{
    margin-top:80px;
  }
 
  .item_group{
   
    .item_inner{
      position: relative;
      
    }
    .group_half{
      padding:20px;
      .min_title{
          color:$theme_color3;
          font-size:40px;
          margin-bottom:10px;
          text-align: left;
        }
    
      .btn_more{
        color: $theme_color3;
        font-size: 20px;
        text-decoration-line: underline;
        margin-top:10px;
      }
      .half_container{
        
        text-align: left;
        margin-bottom:20px;
        
        .half_title{
          font-size: 30px;
          color:$theme_color4;
          
        }
        .mini_title{
          color:$theme_color3;
          font-size:70px;
          position: absolute;
          top:-36px;
          left:20px;
       
        }
        @media screen and (max-width : 767px){
          .mini_title{
            font-size:40px!important;
            top:-10px!important;
            left:20!important;
          }
           
        }
        .btn_link{
          margin:20px 0px;
          display: inline-block;
          >span{
            padding:10px 20px;
          }
        }
        .half_msg{
          font-size: 18px;
          color:$theme_color7;
          font-family: PingFang SC, PingFang SC;;
        }
        .half_text{
          font-size: 18px;
          color:$theme_color1;
          font-family: PingFang SC, PingFang SC;
          
          line-height: 2;
        }
        &:last-child{
          margin-bottom: 0;
        }
      }
      
      
      
      
    }
    .thumb_wrap{
      .half_wrap{
        position: relative;
        text-align: left;
        background:$theme_color6;
        border-radius: 12px;
        // padding:40px 40px;
       
        // min-height: 400px;
        position: relative;
        border-radius: 12px 12px 12px 12px;
      
        .wrap_img{
          width: 100%;
          height: auto;
          
        }
        .wrap_info{
         
          position: absolute;
          left:16%;
          bottom:20%;
          // background: #6E0025;
  
          @media screen and (max-width : 767px) {
  
          .wrap_title{
            font-size: 30px!important;
            
          }
          }
          .wrap_title{
            color:$theme_color1;
            font-size: 60px;
            line-height: 1;
            text-align: left;
            width: 100%;
          }
          .wrap_text{
            color:$theme_color7;
            font-size: 16px;
            margin-top:10px;
            font-family: PingFang SC, PingFang SC;
            width: 70%;
          }
        }
        .payNow{
          position: absolute;
          top:10px;
          right:10px;
          background: #6E0025;
          font-size: 14px;
          color: $theme_color1;
          padding:12px;
          border-radius: 8px;
          
        }
        .text_bottom{
          flex:1;
          width: 150px;
          padding:10px;
          margin-left:10px;
          color:$theme_color4;
        
          height: min-content;
          >span{
            padding:4px 0;
          }
        }
      }
    }
   
    
  }
  
 

  
 .more{
  padding:10px 20px;
  display: inline-block;
 }
 .games_container{
  transition: all 0.25s ease;

 }
 .loadMore{
  height: auto;
  overflow: visible;
 }
  .cate_container{
    padding:50px 0; 
    z-index: 1;
    position: relative;
  }
  .p_img{
    position: absolute;
    z-index:0;

  }
  .p_fb_1{
    left:0;
    top:0;
    transform: translate(-70%, -30%)
  }
  .p_fb_2{
    right:0;
    top:0;
    transform: translate(40%, -60%)
  }
 
  
  .pl_container{
    background-image:url(../../../public/bg/dbbg.png);
    background-size: 100% 100%;
    background-position: center center;
    background-repeat: no-repeat;
    
    .pl_group{
      position: relative;
      height: 100%;
      .pl_inner{
        height: 100%;
        @media screen and (max-width : 767px){
          .pl_grid{
            flex-direction: column;
            .group_img{
              width: 100%!important;
            }
            .pl_box{
              padding:50px 20px!important;
              .star_group{
                font-size: 14px!important;
                height: 60px!important;
                img{
                  width:16px!important;
                  height: 16px!important;
                }
              }
            }
            
          }
            
        }
        .pl_grid{
          position: relative;
          height: 100%;
          .group_img{
            width:35%;
          }
          .pl_box{
            padding:50px 30px;
            background:$theme_bg;
            flex:1;
            position: relative;
            height: 100%;
           .box_msg{
            font-family: PingFang SC, PingFang SC;
            font-size: 14px;
            font-weight: 300;
            line-height: 30px;
            text-align: left;
           }
           .box_title{
            font-size: 30px;
            padding:20px 0;
           }
          .star_group{
             margin-top:30px;
             height: 75px;
             border:1px solid #fff;
             font-size: 20px;
             padding:0 10px;
            
           input{
            width: 60%;
            height: 100%;
            outline: none;
            border:none;
            color:#fff;
            background: transparent;
           }
           .sms_btn{
           width: min-content;
            >img{
              width: 24px;
              height: 24px;
              margin-left:6px;
            }
           }
          }
          .bg_btn{
            padding:10px;
            margin-top:30px;
            display: inline-block;
          }

          }
        }
      }

    }
  }
  .pt_container{
    position: relative;
    top:-80px;
    z-index: 0;
    
    .group_1{
      background: #131612;
      // background-image:url(../../../public/bg/bg1.png);
      // background-size: 100% 100%;
      // background-position: center center;
      // background-repeat: no-repeat;
    }
    .group_2{
      background: #2B2F2A;
      // background-image:url(../../../public/bg/bg2.png);
      // background-size: 100% 100%;
      // background-position: center center;
      // background-repeat: no-repeat;
    }
  }
  .game_group{
    background: #1F231E;
    width: 100%;
    height: 100%;
    padding-top:80px;
    .item_inner{
      padding:40px 40px 120px;
      text-align: left;
      .group_img{
        width: 110px;
        height: 110px;
      }
      .inner_title{
        font-size: 30px;
        margin-top:30px;
      }
      .inner_msg{
        font-family: PingFang SC, PingFang SC;
        font-size: 14px;
        font-weight: 300;
        margin-top:20px;
        line-height: 30px;
      }
    }
  }
  
  .one_group{
    position: relative;
    .bg_img{
      position: absolute;
      left:0;
      right:0;
      top:0;
      width: 100%;
      z-index: 0;
      height: auto;
    }
    .one_img{
      width: 100%;
      height: auto;
      padding-top:30%;
      z-index: 1;
      position: relative;
    }
    .one_title{
      position: absolute;
      text-align: center;
      width: 100%;
      top:15%;
      font-size: 70px;
    }
    @media screen and (max-width : 767px){
      .one_title{
        font-size:24px!important;
        
      }
        
    }
    .one_inner{
      margin-top:20px;
      .img_group{
        position: relative;
        >img{
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          z-index: 1;
          &:nth-child(2){
            left: -10px;
          }
          &:nth-child(3){
            left: -20px;
          }
        }

      }
      .inner_text{
        font-weight: 300px;
        text-align: left;
      }
    }

  }
  .one_group_2{
    .one_title_img{
      margin:0 auto;
      width: 65%;
      >img{
        width: 100%;
        height: auto;
      }
    }
    .inner_tools{
      border-top:1px solid $theme_color8;
      margin-top:80px;
      .one_tool{
        padding:30px 0;
        border-bottom:1px solid $theme_color8;
        align-items: baseline;
        .tool_head{
          font-size: 30px;
          align-items: baseline;
          text-align: left;
          .head_msg{
            margin-left: 30px;
            font-size: 24px;
          }
        }
        @media screen and (max-width : 767px){
          .tool_head{
            font-size:14px!important;
            .head_msg{
              font-size:10px!important;
              margin-left:6px!important;
            }
          }
           .tool_tab{
              font-size: 12px!important;
            .arrow{
             
              margin-left:4px!important;
            }
           
          }
            
        }
        .tool_tab{
          color:$theme_color8;
          .arrow{
            font-size: 20px;
            margin-left:10px;
          }
          &:hover{
            color:$theme_color3;
          }
        }
        
      }
    }
  }
  .one_group_3{
    .one_title_3{
      width: 60%;
      margin:0 auto;
      font-size: 70px;
      
    }
    @media screen and (max-width : 767px){
      .one_title_3{
        font-size:24px!important;
        
      }
        
    }
    .one_card{
      padding:50px;
      background: #1C3725;
      margin-top:30px;
      .one_star_group{
        >img{
          background: #1C3725;
          width:35px;
          height: 35px;
        }
        >img + img{
          margin-left:5px;
        }
      }
      
      .card_msg{
        font-size: 20px;
        line-height: 2;
        text-align: left;
        margin-top:20px;
      }
      @media screen and (max-width : 767px){
        .card_msg{
          font-size:14px!important;
          font-family: ingFang SC, PingFang SC;
          
        }
        .head_img{
          width: 50px!important;
          height: 50px!important;
           margin-right:10px!important;
        }
        .head_name{
          font-size: 14px!important;
        }
        .tail_img{
          width:80px!important;
        }
          
      }
      .card_tool{
        margin-top:30px;
      }
      .tool_head{
        align-items: center;
        .head_img{
          width: 120px;
          height: 120px;
          margin-right:30px;
          >img{
            width: 100%;
            height: 100%;
          }
        }
        .head_name{
          font-size: 22px;
        }
      }
      .tail_img{
        width: 220px;
        
      }
    }
  }

}
</style>
<style lang="scss">

.swiper-pagination-bullet-active{
  background: $theme_color3 !important;
  width: 80px!important;
}
@media screen and (max-width : 1200px) {
  
.banner_left{

  left:8%!important;
}
}
</style>